/* eslint-disable react/prop-types */
import Head from 'next/head';
import PropTypes from 'prop-types';
import React from 'react';

const CommonMeta = (props) => {
  const environment = process.env.NEXT_PUBLIC_SENTRY_ENV;
  const productSchemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'myAster',
    url: 'https://www.myaster.com/',
  };

  return (
    <Head>
      <title>
        {props?.metaData?.title ? `${props?.metaData?.title}` : 'myAster – Your Personal Healthcare Assistant'}
      </title>
      <meta name="apple-itunes-app" content="app-id=1562991616, app-argument=https://www.myaster.com/" />
      <meta
        key="description"
        name="description"
        content={props?.metaData?.description ? props?.metaData?.description : 'Aster Virtual Care Platform'}
      />
      <meta name="facebook-domain-verification" content="r3j289er1aut2ipi5v707kgxw4d0ui" />
      {environment !== 'PROD-F' &&
        environment !== 'PREPROD-F' && 
        environment !== 'PRODKSA-F' && <meta name="robots" content="noindex,nofollow" />}
      {props?.metaData?.meta?.map((meta, key) => {
        if (meta.name === 'canonical') {
          // setting canonical tag from _app.js as it will add in all pages of site. to avoid duplicate tag, commenting this one will keep if need in future.
          // return <link key={meta.name} rel='canonical' href={meta.value} />;
        } else if (meta.name.indexOf('og:') !== -1) {
          return <meta key={meta.name} property={meta.name} content={meta.value} />;
        } else if (meta.name === 'alternate') {
          return <link key={meta.name} rel="alternate" hrefLang={meta?.hreflang} href={meta.value} />;
        } else {
          return <meta key={meta.name} name={meta.name} content={meta.value} />;
        }
      })}
      <meta charSet="utf-8" />
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content=" initial-scale=1, shrink-to-fit=no,minimum-scale=1,maximum-scale=1" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchemaData) }} />
    </Head>
  );
};

CommonMeta.propTypes = {
  metaData: PropTypes.any,
};
export default CommonMeta;
